import React from 'react';
import { useParams } from 'react-router-dom';
import { EventFormPublic } from './EventFormPublic';
import { V1EventFormPublic } from '../../v1/components/forms/V1EventFormPublic';
import { useEventForm } from '../../../hooks/useEventForms';
import { useEventContext } from '../../contexts/EventContext';
import { Loader2 } from 'lucide-react';

// Wrapper that routes to V1 or V2 form component based on form type
export const EventFormWrapper: React.FC = () => {
  const { form_slug } = useParams<{ form_slug: string }>();
  const { eventSlug } = useEventContext();

  // Fetch form data to determine if it's V1 or V2
  const { data: form, isLoading, error } = useEventForm(eventSlug, form_slug!);
  console.log('[EventFormWrapper] Debug info:', {
    eventSlug,
    form_slug,
    form,
    isLoading,
    error
  });

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-gray-500" />
      </div>
    );
  }

  // If there's an error or no form, check if it's a V1 form by trying V1 endpoint
  if (error || !form) {
    // For now, assume it's a V1 form if we get an error from V2 endpoint
    return <V1EventFormPublic />;
  }

  // Check if this is a V1 form (no submitterSurvey or surveyInfo indicates V1)
  const isV1Form = !form?.submitterSurvey ||
                   !form?.surveyInfo ||
                   form.surveyInfo.totalPages === 0;

  if (isV1Form) {
    return <V1EventFormPublic />;
  }

  return <EventFormPublic />;
};